import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { getLatestWorks, workTypeLabel, formatViews } from "@/lib/workUtils";

export default function LatestWorks() {
  const list = getLatestWorks(8);
  return (
    <section className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full px-4 md:px-8">
        <SectionHeading
          title="最新更新"
          subtitle="按更新时间倒序，第一时间掌握影视动态"
          moreTo="/category/tv"
          moreLabel="更多更新"
        />
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
          {list.map((work) => (
            <Link
              key={work.id}
              to={`/detail/${work.id}`}
              className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
            >
              <div className="h-20 w-14 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={work.poster}
                  alt={`${work.title}海报`}
                  title={`${work.title} 剧情介绍`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="line-clamp-1 font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
                    {work.title}
                  </h3>
                  <span className="shrink-0 rounded bg-primary-50 px-1.5 py-0.5 text-[10px] font-medium text-primary-700">
                    {workTypeLabel(work.type)}
                  </span>
                </div>
                <p className="mt-1 line-clamp-1 text-xs text-foreground-600">{work.synopsis}</p>
                <div className="mt-1.5 flex items-center gap-3 text-[11px] text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line" />
                    {work.updatedAt}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {formatViews(work.views)}
                  </span>
                  <span className="text-accent-700">{work.status}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}